import { SortOrder } from '@models';

const studyStageAscending = [
  'Startup',
  'Enrollment',
  'Maintenance',
  'Closeout',
  'All Milestones Completed'
];
const studyPhaseAscending = [
  'I',
  'IA',
  'IB',
  'I/IB',
  'IB/IIA',
  'I/II',
  'II',
  'II/IIA',
  'IIA',
  'IIB',
  'II/III',
  'III',
  'IIIA',
  'IIIB',
  'IIIB/IV',
  'IV'
];
const milestonesStatusAscending = [
  'Upcoming',
  'On Track',
  'At Risk',
  'Past Due',
  'Completed',
  'Completed | Timing unknown',
  'Completed | Accelerated',
  'Completed | On time',
  'Completed | Late'
];
const nextMilestoneAscending = [
  'Award date',
  'Evidence of agreement',
  'Final protocol received',
  'First study site activated',
  'First subject screened',
  'First subject enrolled',
  '50% sites activated',
  'Last site activated',
  '50% subjects enrolled',
  'Last subject enrolled',
  'Last subject last visit',
  'Database lock',
  'Final TLFs to MW',
  'Final clinical study report delivery',
  'All Milestones Completed'
];

const SORT_ORDER: SortOrder[] = [
  {
    type: 'studyStage',
    sortingAscending: studyStageAscending,
    sortingDescending: [...studyStageAscending].reverse()
  },
  {
    type: 'studyPhase',
    sortingAscending: studyPhaseAscending,
    sortingDescending: [...studyPhaseAscending].reverse()
  },
  {
    type: 'milestoneStatus',
    sortingAscending: milestonesStatusAscending,
    sortingDescending: [...milestonesStatusAscending].reverse()
  },
  {
    type: 'nextMilestone',
    sortingAscending: nextMilestoneAscending,
    sortingDescending: [...nextMilestoneAscending].reverse()
  },
  {
    type: 'therapeuticArea',
    alphabetical: true
  },
  {
    type: 'indication',
    alphabetical: true
  },
  {
    type: 'drugAsset',
    alphabetical: true
  },
  {
    type: 'status',
    alphabetical: true
  },
  {
    type: 'fspStudy',
    alphabetical: true
  }
];

export { SORT_ORDER };
